export default [
    { // 견학체험
        path: 'expr',
        children: [
            { // 프로그램 관리
                path: 'prgrm-mng',
                redirect: { name: 'ExprPrgrmList' },
                children: [
                    {
                        path: 'list',
                        name: 'ExprPrgrmList',
                        meta: { menu: 'expr', keepAlive: true },
                        component: () => import('@/pages/resvMng/expr/prgrmMng/PrgrmListView.vue'),
                        props: (route) => ({
                            rsvtClsfDcd: route.query.rsvtClsfDcd || ''
                        })
                    },
                    {
                        path: 'add',
                        name: 'ExprPrgrmInsert',
                        meta: { menu: 'expr', keepAlive: false },
                        component: () => import('@/pages/resvMng/expr/prgrmMng/PrgrmInsertView.vue'),
                        props: (route) => ({
                            ftrPrgrmDcd: route.query.ftrPrgrmDcd || ''
                        })
                    },
                    {
                        path: 'modify/:ftrPrgrmId',
                        name: 'ExprPrgrmUpdate',
                        meta: { menu: 'expr', keepAlive: false },
                        component: () => import('@/pages/resvMng/expr/prgrmMng/PrgrmUpdateView.vue'),
                        props: (route) => ({
                            ftrPrgrmDcd: route.query.ftrPrgrmDcd || '',
                            ftrPrgrmId: route.params.ftrPrgrmId || ''
                        })
                    },
                    {
                        path: 'prgrm-cpct-popup',
                        name: 'ExprPrgrmCpctPopup',
                        meta: { menu: 'expr', keepAlive: false },
                        component: () => import('@/pages/resvMng/expr/prgrmMng/components/PrgrmCpctPopup.vue'),
                        props: (route) => ({
                            ftrPrgrmId: route.query.ftrPrgrmId || '',
                            rsvtClsfDcd: route.query.rsvtClsfDcd || ''
                        })
                    },
                ]
            },
            { // 견학/체험 통계
                path: 'expr-stats',
                redirect: { name: 'ExprStatsList' },
                children: [
                    {
                        path: 'list',
                        name: 'ExprStatsList',
                        meta: { menu: 'expr', keepAlive: true },
                        component: () => import('@/pages/resvMng/expr/exprStats/ExprStatsContainer.vue'),
                    },
                ]
            },
            {   // 예약 관리
                path: 'rsvt-mng',
                redirect: { name: 'ExprRsvtMngList' },
                children: [
                    {
                        path: 'list',
                        name: 'ExprRsvtMngList',
                        meta: { menu: 'expr', keepAlive: true },
                        component: () => import('@/pages/resvMng/expr/rsvtMng/RsvtMngListView.vue')
                    },
                    {
                        path: 'add',
                        name: 'ExprRsvtMngInsert',
                        meta: { menu: 'expr', keepAlive: false },
                        component: () => import('@/pages/resvMng/expr/rsvtMng/RsvtMngInsertView.vue'),
                        props: (route) => ({
                            rsvtClsfDcd: route.query.rsvtClsfDcd || '',
                            rcptTypeDcd: route.query.rcptTypeDcd || ''
                        })
                    },
                    {
                        path: 'copy-add',
                        name: 'ExprRsvtMngCopyInsert',
                        meta: { menu: 'expr', keepAlive: false },
                        component: () => import('@/pages/resvMng/expr/rsvtMng/RsvtMngCopyInsertView.vue'),
                        props: (route) => ({
                            rsvtClsfDcd: route.query.rsvtClsfDcd || '',
                            rcptTypeDcd: route.query.rcptTypeDcd || ''
                        })
                    },
                    {
                        path: 'modify',
                        name: 'ExprRsvtMngUpdate',
                        meta: { menu: 'expr', keepAlive: false },
                        component: () => import('@/pages/resvMng/expr/rsvtMng/RsvtMngUpdateView.vue'),
                        props: (route) => ({
                            rsvtClsfDcd: route.query.rsvtClsfDcd || '',
                            ftrPrgrmId: route.query.ftrPrgrmId || '',
                            ftrSsnbSn: route.query.ftrSsnbSn || '',
                            rsvtId: route.query.rsvtId || '',
                            ftrRsvtId: route.query.ftrRsvtId || '',
                            rcptTypeDcd: route.query.rcptTypeDcd || ''
                        })
                    },
                    {
                        path: 'prgrm-list-popup',
                        name: 'ExprPrgrmListPopup',
                        meta: { menu: 'expr', keepAlive: false },
                        component: () => import('@/pages/resvMng/expr/rsvtMng/components/PrgrmListPopup.vue'),
                    },
                ]
            },
            {   // 예약제한관리
                path: 'rsvt-lmt-mng',
                redirect: { name: 'ExprRsvtLmtMngList' },
                children: [
                    {
                        path: 'calendar',
                        name: 'ExprRsvtLmtMngList',
                        meta: { menu: 'expr', keepAlive: true },
                        component: () => import('@/pages/resvMng/expr/rsvtLmtMng/RsvtLmtMngCalendarView.vue')
                    },
                ]
            },
            {   // 예약현황관리
                path: 'rsvt-stat-mng',
                redirect: { name: 'ExprRsvtStatMngList' },
                children: [
                    {
                        path: 'calendar',
                        name: 'ExprRsvtStatMngList',
                        meta: { menu: 'expr', keepAlive: true },
                        component: () => import('@/pages/resvMng/expr/rsvtStatMng/RsvtStatMngCalendarView.vue')
                    },
                ]
            },
        ]
    },
]
